import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";

declare var ko: any;

export class usersList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected roleFilter: multipleSelector_template;
    protected brandFilter: multipleSelector_template;
    protected isActiveFilter: multipleSelector_template;
    protected filterPreset: filterPreset_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return `
        <div class="sub-header filter-preset w-justify ">
        ` + this.filterPreset.getHtmlBuild() + `
        </div> 
          
            <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div>
                            ` + this.roleFilter.getHtmlBuild() + `
                        </div>
                        <div>
                            ` + this.brandFilter.getHtmlBuild() + `
                        </div>
                        <div>
                            ` + this.isActiveFilter.getHtmlBuild() + `
                        </div>
                        
                    </div>
                </div>
            </div>
            
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-roles"></div>
                    <div id="selected-brands"></div>
                    <div id="selected-active"></div>
                </div>
            </div> 
            
            <div class="list-header w-justify" >

                <div class="w-left" data-bind="if: isAddButtonShown">
                    <button data-bind="click: onClickAdd" class="btn secondary icon i-user-add" type="button">Add user</button>
                </div>

                <div class="w-center">
                
                    <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                        <div class="w-search-feild icon i-search2">
                            <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                            <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                            <input data-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                            <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                        </div>
                    </div>
                </div>

                <div class="w-right">
                    <button
                        style="margin: 10px"
                        data-bind="click : onClickExportToCSV , css: { 'is-disable': exportInProgress }, text : exportTextBox"
                        class="btn secondary icon i-export" type="button">
                    </button>
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
            </div>
            
            
            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'fullName') }, css: { 'list-sort-desc': orderByAndDirection()=='fullName_DESC', 'list-sort-asc': orderByAndDirection()=='fullName_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'loginName') }, css: { 'list-sort-desc': orderByAndDirection()=='loginName_DESC', 'list-sort-asc': orderByAndDirection()=='loginName_ASC' }">User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'email') }, css: { 'list-sort-desc': orderByAndDirection()=='email_DESC', 'list-sort-asc': orderByAndDirection()=='email_ASC' }">Email</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'fullNameEditedBy') }, css: { 'list-sort-desc': orderByAndDirection()=='fullNameEditedBy_DESC', 'list-sort-asc': orderByAndDirection()=='fullNameEditedBy_ASC' }">Last Edited By</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateLastLogin') }, css: { 'list-sort-desc': orderByAndDirection()=='dateLastLogin_DESC', 'list-sort-asc': orderByAndDirection()=='dateLastLogin_ASC' }">Last Login Date</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: users">
    
                        <tr  class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }" class="flex">
                                <!--<button class="btn no-bg icon i-star-full" type="button"></button>-->
                                <a class="right-click" data-bind="attr: { href : emakiProfile }">
                                    <div class="w-user-img"><img class="user-img" data-bind="attr:{src: pictureUrl}" alt=""></div>
                                </a>
                                <a class="right-click" data-bind="attr: { href : emakiProfile }">
                                    <span data-bind="text: fullName"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiProfile }"><span data-bind="text: loginName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiProfile }"><span data-bind="text: email"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiProfile }"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiProfile }"><span data-bind="text: dateUpdate"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiProfile }"><span data-bind="text: fullNameEditedBy"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiProfile }"><span data-bind="text: dateLastLogin"></span></a></td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>    
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.roleFilter = new multipleSelector_template("roleFilter", this.getTemplateViewModel(), this.caller);

        this.roleFilter.setLabel("Roles");
        this.roleFilter.setFilterContainerClass('margin-neg');
        this.roleFilter.setTagContainerId('selected-roles');
        this.roleFilter.setTagContainerCaption('Selected roles:');


        this.brandFilter = new multipleSelector_template("brandFilter", this.getTemplateViewModel(), this.caller);

        this.brandFilter.setLabel("Brands");
        this.brandFilter.setFilterContainerClass('margin-neg');
        this.brandFilter.setTagContainerId('selected-brands');
        this.brandFilter.setTagContainerCaption('Selected brands:');


        this.isActiveFilter = new multipleSelector_template("isActiveFilter", this.getTemplateViewModel(), this.caller);
        this.isActiveFilter.setLabel("Active");
        this.isActiveFilter.setFilterContainerClass('margin-neg');
        this.isActiveFilter.setTagContainerId('selected-active');
        this.isActiveFilter.setTagContainerCaption('Selected active:');



        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('users-list');
    }

    protected getTemplateName(): string {
        return "usersList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("fullName")
            , orderByDirection: ko.observable("ASC")
            , users: ko.observableArray([])
            , orderByAndDirection: ko.observable("fullName_ASC")
            , isAddButtonShown: ko.observable(false)
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickView: function (data, event) {
                huit_neuf_this.onClickView(data.id);
            }
            , onClickEarnings: function (data, event) {
                huit_neuf_this.onClickEarnings(data.id);
            }
            , onClickAdd: function () {
                huit_neuf_this.onClickAdd();
            }
            , exportInProgress: ko.observable(false)
            , exportTextBox: ko.observable("Export to CSV")
            , onClickExportToCSV: function() {
                huit_neuf_this.onClickExportToCSV();
            },
        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            , roleFilter: this.getTemplateViewModel().roleFilter
            , brandFilter: this.getTemplateViewModel().brandFilter
            , isActiveFilter: this.getTemplateViewModel().isActiveFilter
            , searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName()
            , searchPresetType: 'users-list'
            ,filters      : {
                keywords : this.getTemplateViewModel().filter.filterKeyword,
                roleIds : this.getTemplateViewModel().roleFilter.selectedItems,
                brandIds : this.getTemplateViewModel().brandFilter.selectedItems,
                isActive : this.getTemplateViewModel().isActiveFilter.selectedItems,
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.userListReorder();
    }

    public onClickView(id) {

        this.caller.viewUserProfile(id);
    }

    public onClickEarnings(id) {

        this.caller.earningsUser(id);
    }

    public onClickAdd() {

        this.caller.addUser();
    }

    public onClickExportToCSV() {
        this.getTemplateViewModel().exportInProgress(true);
        this.getTemplateViewModel().exportTextBox("Exporting...");

        const filters = this.getViewModelForRequest().filters;
        this.caller.exportToCSV(null, filters);
    }

    public setUsers(users: Array<{ pictureUrl: string, emakiProfile: string, fullName: string, loginName: string, email: string, dateCreation: string }>): void {

        this.getTemplateViewModel().users(users);
    }

    public setAddButtonShown(isAddButtonShown: boolean) {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }


    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setSearchPresets(presets) {
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response) {
        this.filterPreset.addCreatedPresetToList(response);
    }


    public setFilterSelectedItems(objFilter, urlParams){
        let splitString = [];

        // Multi select filters.
        if(Array.isArray(urlParams)){
            urlParams = urlParams.toString();
        }
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {

                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public setViewModelFromRequest(urlParams) {
        const {isActive, brandIds, roleIds} = urlParams


        if (urlParams != null) {
            const newUrlParams = {
                isActiveFilter: isActive,
                brandFilter: brandIds,
                roleFilter: roleIds
            }
            this.setFilterSelectedItems(this.roleFilter, newUrlParams.roleFilter);
            this.setFilterSelectedItems(this.brandFilter, newUrlParams.brandFilter);
            this.setFilterSelectedItems(this.isActiveFilter, newUrlParams.isActiveFilter);

        }
    }

    public setDefaultFilters() {
        this.setFilterSelectedItems(this.isActiveFilter, 1);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/usersList_template.ts